export default __webpack_public_path__ + "static/media/JENNIFER LAWRENCE.545ee4d6.jpg";